<template>
    <main-layout class="bg-gray-100 min-h-screen flex flex-col">
        <!-- En-tête + CTA sur fond dégradé -->
        <div class="bg-gradient-to-b from-secondary to-primary">
            <div class="px-2 py-3">
                <app-header icon="factory" class="text-white">
                    <div class="flex items-center justify-between">
                        <h1 class="text-2xl font-semibold tracking-wide">Installations</h1>
                    </div>
                </app-header>
                <!-- Action principale (garde id=main-action pour le JS) -->
                <action-bar :back="{ name: 'liste-detenteurs' }">
                    <a class="bg-white transition px-4 py-2 rounded-lg text-primary text-sm font-medium"
                        id="main-action" @click.prevent="addInstallation">
                        Ajouter
                    </a>
                </action-bar>

                <!-- Section recherche -->
                <div class="pb-4">
                    <filter-bar @searchBarChanged="updateSearch" :gotFilter="true" filterText="Installation avec fluide"
                        @filterValChanged="changeList" placeholderFilter="Rechercher par Nom"
                        type-history="installation" />
                </div>

                <button id="btnFilterActive" @click="toggleList"
                    class="px-4 py-2 rounded-lg text-md flex items-center justify-center gap-2 mb-5" :class="listVisible === 'fluide'
                        ? 'bg-vert text-white'
                        : 'bg-gray-300 text-gray-800'">
                    <i class="inline-block h-6 w-6 mask mask-snow"
                        :class="listVisible === 'fluide' ? 'bg-white' : 'bg-gray-800'"></i>
                    <span>
                        {{ listVisible === 'fluide' ? 'Avec fluide' : 'Sans fluide' }}
                    </span>
                </button>

            </div>
        </div>

        <!-- Corps arrondi + dégradé clair -->
        <main
            class="bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl pb-28">
            <!-- Liste (avec fluide) -->
            <div class="mx-1 my-2 shadow-2xl rounded-lg overflow-hidden bg-white" v-show="listVisible === 'fluide'">
                <installation-item v-for="installation in filterListFluide" :key="installation.id"
                    :installation="installation" />
            </div>

            <!-- Liste (sans fluide) -->
            <div class="mx-1 my-2 shadow-2xl rounded-lg overflow-hidden bg-white" v-show="listVisible === 'noFluide'">
                <installation-item v-for="installation in filterListNoFluide" :key="installation.id"
                    :installation="installation" />
            </div>
        </main>
    </main-layout>
</template>

<script>
import InstallationItem from './InstallationItem.vue'
import Installation from '../../js/models/Installation'

export default {
    data() {
        return {
            installations: [],
            strSearch: '',
            listVisible: 'fluide',
        }
    },
    computed: {
        filterListFluide() {
            if (!_.isEmpty(this.installations)) {

                return this.installations.filter(install => {
                    let check = false;
                    if (install.marque && install.marque.toLowerCase().includes(this.strSearch)) {
                        check = true
                    }
                    if (install.modele && install.modele.toLowerCase().includes(this.strSearch)) {
                        check = true
                    }
                    if (_.has(install, 'nom') && install.nom.toLowerCase().includes(this.strSearch)) {
                        check = true
                    }
                    if (_.has(install, 'fluide') && !_.isEmpty(install.fluide)) {
                        if (install.fluide.nom.toLowerCase().includes(this.strSearch)) {
                            check = true
                        }
                    } else {
                        check = false;
                    }

                    if (install.hasOwnProperty('custom') && install.custom !== null && install.custom.toLowerCase().includes(this.strSearch)) {
                        check = true
                    }

                    if (check === true) {
                        return install
                    }
                })
            }
        },

        filterListNoFluide() {
            if (!_.isEmpty(this.installations)) {

                return this.installations.filter(install => {
                    let check = false;
                    if (install.marque && install.marque.toLowerCase().includes(this.strSearch)) {
                        check = true
                    }
                    if (install.modele && install.modele.toLowerCase().includes(this.strSearch)) {
                        check = true
                    }
                    if (_.has(install, 'nom') && install.nom.toLowerCase().includes(this.strSearch)) {
                        check = true
                    }
                    if (_.has(install, 'fluide') && !_.isEmpty(install.fluide)) {
                        check = false
                    }
                    if (check === true) {
                        return install
                    }
                })

            }

        }

    },
    methods: {
        fetchInstallations() {
            let idDet = this.$route.params.id;
            Installation
                .getInstallationsForDet(idDet)
                .then(data => {
                    this.installations = _.sortBy(data, [install => install.nom.toUpperCase()])
                })
                .catch()
        },
        addInstallation() {
            let idDet = this.$route.params.id;
            if (JSON.parse(localStorage.getItem('canEditInstallations')) === true) {
                Installation.askAddInstall(idDet);
            } else {
                swal('Action non autorisée', "Vous n'avez pas le droit d'ajouter d'installations, veuillez contacter votre administrateur", 'error')
            }
        },
        updateSearch(str) {
            this.strSearch = String(str[0]).toLowerCase()
        },
        changeList(filter) {
            if (filter === false) {
                this.listVisible = 'noFluide'
            } else {
                this.listVisible = 'fluide'
            }
        },
        toggleList() {
            this.listVisible = this.listVisible === 'fluide' ? 'noFluide' : 'fluide'
        }
    },
    mounted: function () {
        this.fetchInstallations()

    },
    components: {
        InstallationItem
    }
}

</script>



// WEBPACK FOOTER //
// ListeInstallations.vue?010e77b6